import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';
import BrandMark from '../components/BrandMark';

const scrollTo = (id) => (e) => {
  e.preventDefault();
  if (window.location.pathname !== '/') {
    window.location.assign(`/#${id}`);
    return;
  }
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1a3a2e] text-[#f5f1e8] mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <BrandMark tone="light" size="lg" />
          <p className="mt-6 text-[#e3d9c6]/90 font-serif italic text-2xl leading-snug max-w-md">
            Marketing is about the stories you tell &amp; experiences you create.
          </p>
          <p className="mt-4 text-xs tracking-[0.25em] uppercase text-[#e3d9c6]/70">
            create. curate. collaborate.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.2em] uppercase text-[#e3d9c6]/70 mb-5">Navigate</h4>
          <ul className="space-y-3 text-[#f5f1e8]">
            <li><a href="#home" onClick={scrollTo('home')} className="underline-anim">Home</a></li>
            <li><a href="#about" onClick={scrollTo('about')} className="underline-anim">About</a></li>
            <li><a href="#services" onClick={scrollTo('services')} className="underline-anim">Services</a></li>
            <li><Link to="/campaigns" className="underline-anim">Campaigns</Link></li>
            <li><a href="#contact" onClick={scrollTo('contact')} className="underline-anim">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs tracking-[0.2em] uppercase text-[#e3d9c6]/70 mb-5">Get in touch</h4>
          <ul className="space-y-3 text-[#f5f1e8]">
            <li className="flex items-center gap-3"><Mail size={16} /> <a href="mailto:hello@rheagupta.in" className="underline-anim">hello@rheagupta.in</a></li>
            <li className="flex items-center gap-3"><Phone size={16} /> <a href="tel:+919873542454" className="underline-anim">+91 98735 42454</a></li>
            <li className="flex items-center gap-3">
              <Instagram size={16} />
              <a href="https://www.instagram.com/cocratestudio" target="_blank" rel="noreferrer" className="underline-anim">@cocratestudio</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#f5f1e8]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#e3d9c6]/70">
          <p>© {new Date().getFullYear()} Rhea Gupta. All rights reserved.</p>
          <p>An extended arm — Co Crate Studio.</p>
        </div>
      </div>
    </footer>
  );
}
